import { Controller } from "@hotwired/stimulus"

// Global application controller for common actions
export default class extends Controller {
  openModal(event) {
    const modalId = event.currentTarget.dataset.modalId
    const modal = document.getElementById(modalId)

    if (modal) {
      // Get the Stimulus controller instance for the modal
      const modalController = this.application.getControllerForElementAndIdentifier(modal, "modal")
      if (modalController) {
        modalController.open()
      } else {
        // Fallback if modal controller not found
        modal.classList.remove('hidden')
        document.body.style.overflow = 'hidden'
      }
    }
  }
}